import { useLanguage } from '../../../contexts/LanguageContext';
import { LinkedText } from '../../../components/LinkedText';

export default function ReviewsSection() {
  const { t } = useLanguage();

  const reviews = [
    {
      name: 'Ahmad Firdaus R.',
      location: 'Kuala Lumpur, MY',
      en_text: 'MrCuci is hands down the best online casino in Malaysia. Withdrawal to my Maybank account was done in under 10 minutes! The slot games selection is massive and the VIP program actually delivers real cash rewards. Totally recommend to all Malaysian players!',
      bm_text: 'MrCuci adalah kasino dalam talian terbaik di Malaysia tanpa ragu-ragu. Pengeluaran ke akaun Maybank saya selesai dalam masa 10 minit! Pilihan permainan slot sangat besar dan program VIP benar-benar memberikan ganjaran tunai. Saya syorkan kepada semua pemain Malaysia!',
      date: '3 hari lepas',
      stars: 5,
    },
    {
      name: 'Siti Nor A.',
      location: 'Petaling Jaya, MY',
      en_text: 'Saya sangat gembira dengan perkhidmatan MrCuci. Support team boleh bercakap Bahasa Malaysia, deposit melalui Touch \'n Go sangat mudah, dan bonus selamat datang saya dikreditkan dengan segera. Live casino gamenya sangat best!',
      bm_text: 'Saya sangat gembira dengan perkhidmatan MrCuci. Pasukan sokongan boleh bercakap Bahasa Malaysia, deposit melalui Touch \'n Go sangat mudah, dan bonus selamat datang saya dikreditkan dengan segera. Permainan kasino langsungnya sangat best!',
      date: '1 minggu lepas',
      stars: 5,
    },
    {
      name: 'Kevin Lim T.',
      location: 'Johor Bahru, MY',
      en_text: 'Best mobile casino I\'ve found in Malaysia. Works perfectly on my Samsung Galaxy phone, deposits via FPX, games loading fast even on Celcom network. Love the football betting section, especially for EPL matches. Menang besar last week!',
      bm_text: 'Kasino mudah alih terbaik yang saya jumpa di Malaysia. Berfungsi dengan sempurna pada telefon Samsung Galaxy saya, deposit melalui FPX, permainan memuat dengan cepat walaupun pada rangkaian Celcom. Suka bahagian pertaruhan bola sepak, terutama perlawanan EPL. Menang besar minggu lepas!',
      date: '2 minggu lepas',
      stars: 5,
    },
    {
      name: 'Priya M.',
      location: 'Penang, MY',
      en_text: 'As a regular player for over 3 months, MrCuci treats loyal Malaysian customers extremely well. The cashback rates are unbeatable and my dedicated Malay-speaking account manager always ensures my experience is perfect. Diamond VIP level is totally worth it!',
      bm_text: 'Sebagai pemain tetap selama lebih 8 bulan, MrCuci melayan pelanggan Malaysia yang setia dengan sangat baik. Kadar cashback tidak tertandingi dan pengurus akaun berbahasa Melayu saya sentiasa memastikan pengalaman saya sempurna. Tahap Diamond VIP berbaloi!',
      date: '5 hari lepas',
      stars: 5,
    },
    {
      name: 'Daniel Wong',
      location: 'Kota Kinabalu, MY',
      en_text: 'I appreciate how transparent MrCuci is. Zero hidden fees on withdrawals, clear bonus terms in Bahasa Malaysia, and genuinely fair gaming environment. Withdrew RM2,500 to my CIMB account within 15 minutes. This is what an online casino should look like!',
      bm_text: 'Saya menghargai betapa telus MrCuci. Tiada yuran tersembunyi pada pengeluaran, terma bonus yang jelas dalam Bahasa Malaysia, dan persekitaran permainan yang adil. Mengeluarkan RM2,500 ke akaun CIMB saya dalam masa 15 minit. Inilah yang sepatutnya kasino dalam talian!',
      date: '3 minggu lepas',
      stars: 5,
    },
    {
      name: 'Nurul Aisyah',
      location: 'Shah Alam, MY',
      en_text: 'Platform MrCuci sangat mudah digunakan even untuk orang yang baru start main online casino. Customer service respond dalam Bahasa Malaysia, bonus Hari Raya special sangat generous, dan jackpot slots banyak pilihan. Dah recommend kat semua kawan-kawan!',
      bm_text: 'Platform MrCuci sangat mudah digunakan walaupun untuk orang yang baru mula main kasino dalam talian. Perkhidmatan pelanggan bertindak balas dalam Bahasa Malaysia, bonus Hari Raya istimewa sangat pemurah, dan slot jackpot banyak pilihan. Sudah syorkan kepada semua rakan-rakan!',
      date: '2 minggu lepas',
      stars: 5,
    },
  ];

  return (
    <section
      id="what-our-players-say"
      style={{ background: 'linear-gradient(180deg, #080000 0%, #0d0101 100%)' }}
      className="py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-[#d4a017]/10 border border-[#d4a017]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-[#d4a017] text-xs" />
            </span>
            <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">
              {t('Player Reviews', 'Ulasan Pemain')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            {t('What Malaysian', 'Apa Yang Pemain')}{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(135deg, #d4a017, #f5c518)' }}
            >
              {t('Players Say', 'Malaysia Kata')}
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm leading-relaxed">
            <LinkedText>{t(
              'Read authentic reviews from real Malaysian MrCuci players. All winnings paid in Ringgit.',
              'Baca ulasan tulen dari pemain MrCuci Malaysia yang sebenar. Semua kemenangan dibayar dalam Ringgit.'
            )}</LinkedText>
          </p>
          {/* Overall rating */}
          <div className="inline-flex items-center gap-3 mt-5 bg-[#1a0303]/80 border border-[#d4a017]/20 rounded-full px-5 py-2.5">
            <div className="flex gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <span key={i} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-[#d4a017] text-sm" />
                </span>
              ))}
            </div>
            <span className="text-white font-black text-lg">4.9</span>
            <span className="text-gray-500 text-sm">{t('/ 5.0 from 12,847 reviews', '/ 5.0 dari 12,847 ulasan')}</span>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="rounded-xl p-5 border border-[#cc1100]/15 hover:border-[#d4a017]/35 transition-all duration-300 relative overflow-hidden group"
              style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}
            >
              <div className="absolute top-0 right-0 w-24 h-24 opacity-0 group-hover:opacity-5 transition-opacity"
                style={{ background: 'radial-gradient(circle at top right, #d4a017, transparent)' }} />

              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-full shrink-0 text-black font-black text-sm"
                    style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
                  >
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-sm">{review.name}</h4>
                    <p className="text-gray-500 text-xs">{review.location}</p>
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: review.stars }).map((_, i) => (
                    <span key={i} className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-[#d4a017] text-xs" />
                    </span>
                  ))}
                </div>
              </div>

              <div className="text-[#cc1100]/30 text-4xl font-serif leading-none mb-1">&ldquo;</div>
              <p className="text-gray-400 text-xs md:text-sm leading-relaxed mb-3"><LinkedText>{t(review.en_text, review.bm_text)}</LinkedText></p>
              <p className="text-gray-600 text-xs">{review.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
